import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';
class ErrorBoundary extends React.Component {
  state = {
    failed: false
  };
  static getDerivedStateFromError() {
    return {
      failed: true
    };
  }
  render() {
    if (this.state.failed) return <main className="container section"><h1>We couldn’t load this page.</h1><p>Please reload, or email <a href="mailto:info@anbelat.com">info@anbelat.com</a>.</p><a href="/">Return home</a></main>;
    return this.props.children;
  }
}
createRoot(document.getElementById('root')).render(<React.StrictMode><ErrorBoundary><App /></ErrorBoundary></React.StrictMode>);
